<template>
  <v-container fluid>
    <v-row dense class="d-flex" style="height: 50px">
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="addVocabularyForm()"
          :disabled=!isAdmin
          >
          <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
        <v-btn
            v-if="(this.sitePath.split('/').length > 2) && (vocabularies.length == 0)"
            rounded
            small
            class="copy-button font-weight-bold"
            @click.stop="copyParentVocabularies()"
            :disabled=!isAdmin
            >
              Copy Parent Menus
        </v-btn>
      </v-col>
      <!-- View Title -->
      <v-col>
        <ViewTitle title="Vocabulary" />
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
      <div style="display: flex;">
        <div class="mr-1">Centro</div>
        <v-switch class="mt-0" v-model="site_vocabulary"></v-switch>
        <div class="ml-1">Site</div>
      </div>
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="vocabularies"
      :headers="fields"
      item-key="id"
      dense
      item-class="qmkey-item-row"
      group-by="vocabulary"
      :search="search"      
    >
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length -1" class="qmkey-vocabulary-datatable">
          <v-btn 
            @click="toggle"
            small
            icon
            :ref="group"
            :data-open="isOpen"
          >
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
          {{ group }}
        </td>
        <td >
          <v-btn 
            small
            icon
            class="qmkey-add-button-vocabulary"
            @click="addVocabularyForm(group)"
            :disabled=!isAdmin 
          >
            <v-icon small>mdi-plus</v-icon>
            Add New Key
          </v-btn>
        </td>
      </template>
      <template v-slot:item.site="{ item }">
          {{sites && sites.some(elem=>elem.id==item.site)?sites.find(elem=>elem.id==item.site).name:item.site}}
      </template>
      <template v-slot:item.vocabulary="{ item }">
        <v-btn
          @click.stop="editVocabularyForm(item)"
          text
          small
          class="qmkey-add-button-site"
          :disabled=!isAdmin
        >
          {{item.vocabulary}}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click.stop="editVocabularyForm(item)"
          :disabled="!isAdmin || allow_path != item.path"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteVocabularyForm(item)"
          :disabled="true || !isAdmin || allow_path != item.path"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- Add /edit dialog && delete site-->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
  </v-container>    
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import QVocabulary from '@/api/QVocabularyItem'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import SearchTextAdmin from '@/components/header/SearchTextAdmin'

export default {
  name: 'VocabularyView',
  components: {
    ViewTitle,
    QVocabulary,
    ModalDialogForm,
    SearchTextAdmin,
  },

  data() {
    return {
      fields: [
        { value: 'id', text: ''},
        { value: 'vocabulary', text: 'Vocabulary' },
        { value: 'key', text: 'Key' },
        { value: 'value', text: 'Value' },
        { value: 'site', text: 'Site' },
        { value: 'path', text: 'Path' },
        { value: 'actions', text: '', sortable:false },
      ],
      message: null,
      alert: false,
      loading: false,
      expanded: [],
      togglers: {},
      search:'',
      is_new: false,

      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: 'Save', // Harcoded text
      submit_action: function () {},
      site_vocabulary: false,
    }
  },

  computed: {
    ...mapState(['isLoading','sites']),
    ...mapState('QVocabulary', ['currentVocabulary',
                                'error',
                                'vocabularies']),
    ...mapGetters(['isAdmin', 'sitePath', "centro_id","centro_data"]),

    allow_path(){
      return this.sitePath + (this.site_vocabulary ? '' : '/' + this.centro_id)//+ '/' + this.centro_id;
    }
  },

   mounted: function() {
     /* this.SET_CURRENT_SITE(this.sitePath) */ // TODO: Remove this line?
     this.GET_VOCABULARIES()
  },

  methods: {
    ...mapActions('QVocabulary', [
      'ADD_VOCABULARY',
      'DELETE_VOCABULARY',
      'GET_VOCABULARY',
      'GET_VOCABULARIES',
      'UPDATE_VOCABULARY',
      'COPY_FROM_PARENT',
    ]),
    ...mapMutations('QVocabulary', ['SET_CURRENT_VOCABULARY']),
    ...mapMutations(['SET_CURRENT_SITE']),
    get_fields(){
      let value_name=null
      let value_key=null
      let value_value=null
      if(this.currentVocabulary && Object.keys(this.currentVocabulary).length>0){
        value_name=this.currentVocabulary.vocabulary
        value_key=this.currentVocabulary.key
        value_value=this.currentVocabulary.value
      }
      return [
        [
          {
            id: 'vocabulary',
            label: 'Vocabulary name',
            //If value_name is not null, then it's true, not required and readonly. On contrary, is false, required and modifiable 
            required: !value_name && this.is_new || !this.is_new,
            value: value_name,
            readonly: !!value_name && this.is_new,
            hidden: null,
            cols: 6,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Vocabulary Name',
          },
          this.site_vocabulary ? {} :
          {
            id: 'centro',
            label: 'Centro',
            //If value_name is not null, then it's true, not required and readonly. On contrary, is false, required and modifiable 
            required: true,
            value: this.centro_id,
            readonly: true,
            hidden: null,
            cols: 6,
            class: null,
            items: [[this.centro_id,this.centro_data.name]],
            component: 'Select',
          },
        ],
        [
          {
            id: 'key',
            label: 'Vocabulary key',
            required: true,
            value: value_key,
            readonly: false,
            hidden: null,
            cols: 6,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Vocabulary Key',
          },
          {
            id: 'value',
            label: 'Vocabulary value',
            required: true,
            value: value_value,
            readonly: false,
            hidden: null,
            cols: 6,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Vocabulary Value',
          },
        ],
      ] 
    },
    // Helper to display Vocabulary name
    vocabularyTitle(data) {
      return '- - '.repeat(data.indent) + data.vocabulary
    },

    // Forms
    addVocabularyForm(parent) {
      this.modal_title = `Add new vocabulary`
      let currentVocabulary={}
      if(parent){
        this.modal_title = `Add new vocabulary key`
        currentVocabulary.vocabulary = parent
      }
      this.is_new=true
      currentVocabulary.path = this.sitePath
      this.SET_CURRENT_VOCABULARY(currentVocabulary)
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.addVocabulary
      this.submit_button_caption = 'Save'
    },

    editVocabularyForm(item) {
      this.is_new=false
      this.SET_CURRENT_VOCABULARY(item)
      this.modal_title = this.site_vocabulary ? `Edit site #${item.id} - ${item.value}` : `Edit centro #${this.centro_data.name} - ${item.value}`;
      this.showModalDialog = true
      this.fields_to_collect = this.get_fields()
      this.submit_action = this.updateVocabulary
      this.submit_button_caption = 'Save'
    },

    deleteVocabularyForm(item) {
      this.SET_CURRENT_VOCABULARY(item)
      this.modal_title = `Delete Site #${item.id} - ${item.value}`
      this.showModalDialog = true
      this.fields_to_collect = []
      this.submit_action = this.deleteVocabulary
      this.submit_button_caption = 'Delete'
    },

    addVocabulary(formdata) {
      QVocabulary.post(this.centro_id, formdata)
        .then(() => {
          this.GET_VOCABULARIES()
          this.showModalDialog=false
          this.SET_CURRENT_VOCABULARY({})
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    updateVocabulary(formdata) {
      QVocabulary.put(this.centro_id, this.currentVocabulary.id, formdata)
        .then(() => {
          this.GET_VOCABULARIES()
          this.showModalDialog=false
          this.SET_CURRENT_VOCABULARY({})
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    deleteVocabulary() {
      QVocabulary.delete(this.centro_id, this.currentVocabulary.id)
        .then(() => {
          this.GET_VOCABULARIES()
          this.showModalDialog=false
          this.SET_CURRENT_VOCABULARY({})
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    copyParentVocabularies() {
        QVocabulary.copyFromParent(this.centro_id)
          .then(() => {
            this.GET_VOCABULARIES();
          })
          .catch (error => {
            this.render_form_errors(error)
          });
    },
    closeAll () {
      Object.keys(this.$refs).forEach(k => {
          //console.log(this.$refs[k])
          if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    openAll () {
      Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    toggle_dialog() {
      this.showModalDialog = false
      this.modal_title = ``
      this.fields_to_collect = []
      ;(this.submit_action = function () {}), (this.submit_button_caption = '')
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },
    setSearchText(search_text) {
      this.search=search_text
    },
  },
}
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
</style>
